import type MarkdownIt from 'markdown-it';

import { courseCalloutPlugin, courseVideoPlugin } from './course-video-plugin';
import { currencyPlugin } from './currency-plugin';

/**
 * Configure the shared Markdown renderer used by course, blog, and Copiloto
 * reading surfaces. A single newline inside a paragraph is a soft break in
 * Markdown; only an explicit hard break should create a new visual line.
 */
export function configureCourseMarkdown(markdown: MarkdownIt) {
  markdown.set({ breaks: false });
  currencyPlugin(markdown);
  courseVideoPlugin(markdown);
  courseCalloutPlugin(markdown);
}
